import React from 'react';
import {FormikErrors, withFormik} from 'formik';
import PropTypes from 'prop-types';
import {RealOwnerAdditionalInformation} from 'commons/models';
import {InferPropTypes} from 'commons/types/Types';
import InnerFormRepresentativeAdditional from './InnerFormRepresentativeAdditional';
import {FieldShape} from 'commons/shapes';
import {formValidator} from 'commons/utils/Functions';

RepresentativeAdditionalForm.propTypes = {
    submitHandler: PropTypes.func.isRequired,
    fields: PropTypes.arrayOf(PropTypes.shape(FieldShape).isRequired).isRequired,
    auxLegalRepresentative: PropTypes.any,
    filterTradedFields: PropTypes.func.isRequired,
};

const FormControl = withFormik<
    InferPropTypes<typeof RepresentativeAdditionalForm.propTypes>,
    RealOwnerAdditionalInformation
>({
    mapPropsToErrors: () => {
        return {
            kycId: '',
            traded: '',
            simplifiedRegimen: '',
            participationPercentage: '',
            quotePersonName: '',
            boardKey: '',
        };
    },
    mapPropsToValues: (props) => {
        const {auxLegalRepresentative} = props;
        if (auxLegalRepresentative) {
            return {
                kycId: auxLegalRepresentative.kycId || 0,
                traded: auxLegalRepresentative.traded || false,
                simplifiedRegimen: auxLegalRepresentative.simplifiedRegimen || false,
                participationPercentage: auxLegalRepresentative.participationPercentage,
                quotePersonName: auxLegalRepresentative.quotePersonName,
                boardKey: auxLegalRepresentative.boardKey,
            };
        } else {
            return {
                kycId: 0,
                traded: false,
                simplifiedRegimen: false,
            };
        }
        
    },
    validateOnBlur: true,
    validateOnChange: true,
    validate: (values: RealOwnerAdditionalInformation, props) => {
        const errors: FormikErrors<RealOwnerAdditionalInformation> = {};
        formValidator(props.fields, errors, values);
        return errors;
    },
    handleSubmit: (values, actions) => {
        actions.setSubmitting(false);
        actions.props.submitHandler({...values});
    },
})(InnerFormRepresentativeAdditional);

function RepresentativeAdditionalForm(
    props: InferPropTypes<typeof RepresentativeAdditionalForm.propTypes>
) {
    const {submitHandler, fields, auxLegalRepresentative, filterTradedFields} = props;

    /* eslint-disable react/jsx-handler-names */
    return (
        <FormControl
            fields={fields}
            submitHandler={submitHandler}
            auxLegalRepresentative={auxLegalRepresentative}
            filterTradedFields={filterTradedFields}
        />
    );
}

export default RepresentativeAdditionalForm;
